import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimpleCarousel = ({
  children,
  isMobile
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const childrenArray = Array.isArray(children) ? children : [children];
  const transform = isMobile ? 'translate(25%, 0)' : 'translate(-50%, -50%)';
  return /*#__PURE__*/_jsxs(Box, {
    alignItems: "center",
    display: "flex",
    marginBlockEnd: "200",
    children: [childrenArray[currentIndex], childrenArray.length > 1 && /*#__PURE__*/_jsx("div", {
      style: {
        transform
      },
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: () => setCurrentIndex((currentIndex + 1) % childrenArray.length),
        shape: "circle",
        children: /*#__PURE__*/_jsx(RightIcon, {})
      })
    })]
  });
};
export default SimpleCarousel;